import * as styles from './styles';
import { colors as uiColors } from '@cobliteam/ui/theme';
import { cn } from '@cobliteam/ui/utils';
import { Typography } from '@material-ui/core';

interface IProps {
  title?: string;
  message?: string;
  fill?: string;
  className?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Loading = ({ title, message, fill, className }: IProps) => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <div className='flex flex-col items-center justify-center gap-2'>
        {title && <Typography variant='body1'>{title}</Typography>}
        {message && (
          <Typography variant='caption' color='textSecondary'>
            {message}
          </Typography>
        )}
      </div>
      <div>
        <svg className={className} viewBox='0 0 52 14' height='14px' width='52px'>
          <g stroke='none' strokeWidth='1' fill={fill || uiColors.primary[9]} fillRule='evenodd'>
            <circle className={cn(styles.circle, styles.circleLoading)} cx='7' cy='7' r='7' />
            <circle className={cn(styles.circle, styles.circleLoading)} cx='26' cy='7' r='7' />
            <circle className={cn(styles.circle, styles.circleLoading)} cx='45' cy='7' r='7' />
          </g>
        </svg>
      </div>
    </div>
  );
};
